import type { PlatformOrg } from "@/api/client";
import type { Tone } from "@/ui/Badge";

export type Licence = NonNullable<PlatformOrg["licence"]>;

/** How each licence status reads in the platform console. */
export const LICENCE: Record<Licence["status"], { label: string; tone: Tone }> = {
  trial: { label: "Trial", tone: "violet" },
  active: { label: "Active", tone: "ok" },
  suspended: { label: "Suspended", tone: "danger" },
};

/** A day as people say it, such as "Oct 31, 2027"; "Never" for none. */
export function day(iso: string | null): string {
  if (!iso) return "Never";
  return new Date(iso).toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    timeZone: "UTC",
  });
}
